export default __webpack_public_path__ + "static/tour-use-do-08901ecf3eadd23de664cf009fc6d0d74bf5f48f5c1e6dd52a828730cf0e5285.png";